import {sortArrayByKey} from "./shared/functions";

/**
 * Post-Process incoming list or item data
 *
 * @param resource
 * @param type
 * @param params
 * @param rdata
 *
 * @return {*}
 */
export const postProcessData = (resource, type, params, rdata) => {
    if (type === 'GET_LIST') {

        // Filter data if filters are present
        if (params.filter) {
            rdata = filterListData(resource, type, params, rdata);
        }

        // Sort data according to sort parameters
        if (params.sort.field && params.sort.order) {
            rdata = sortListData(resource, type, params, rdata);
        }

        // Process data for Locations
        if (resource === 'Locations' || resource === 'LocationsMin') {
            rdata = processLocationsData(rdata);
        }

        // Pagination will not be handled here as page will be 1 and all data is returned

    }
    if (type === 'GET_ONE') {
        if (resource === 'ScheduledReports') {
            rdata = processScheduledReportData(rdata);
        }
    }
    return rdata;
};

/**
 * Filter incoming data
 *
 * @param resource
 * @param type
 * @param params
 * @param rdata
 * @return {*}
 */
const filterListData = (resource, type, params, rdata) => {
    return rdata;
};

/**
 * Sort incoming data
 *
 * @param resource
 * @param type
 * @param params
 * @param rdata
 */
const sortListData = (resource, type, params, rdata) => {
    rdata.data = sortArrayByKey(rdata.data, params.sort.field, params.sort.order);
    return rdata;
};

/* ID and Key exported functions ::::: */

/**
 * Generate a unique id for list items (per React's unique-key requirement)
 */
export const generateId = () => {
    let dt = new Date().getTime();
    const id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
    return id;
};

/**
 * Mark resources without ids or with different unique identifiers
 */
export const setUniqueKeys = (resource) => {
    const parseParams = {
        hasNameKeys: false,
        needsId: false,
        parentKey: null,
        idKey: null,
    };
    if (resource === 'Configurations') {
        parseParams.idKey = 'name';
    }
    if (resource === 'ScheduledReports') {
        parseParams.idKey = 'uuid';
    }
    if (resource === 'VIPSignups') {
        parseParams.idKey = 'registration_location';
    }
    return parseParams;
};

/* Miscellaneous functions ::::: */

/**
 * Process Locations data after retrieval
 *
 * @param rdata
 * @returns {{data}|*}
 */
const processLocationsData = (rdata) => {
    if (!rdata.data || !rdata.data.length) {
        return rdata;
    }
    rdata.data.forEach(function (loc, idx) {
        const id = (loc.id) ? loc.id.toString() : '';
        const name = (loc.name) ? ' - ' + loc.name.toString() : '';
        const city = (loc.city) ? ' - ' + loc.city.toString() : '';
        const state = (loc.state) ? ', ' + loc.state.toString() : '';
        // Create a display name for filters
        loc.filter_name = id + name + city + state;
    });
    return rdata;
};

/**
 * Process Scheduled Report data after retrieval
 *
 * @param rdata
 * @returns {*}
 */
const processScheduledReportData = (rdata) => {
    rdata.data.date_range_type = (rdata.data.payload.dateRange.daysBack > 0) ? 'relative' : 'specific';
    const locationData = rdata.data.payload.location;
    let filterType = '';
    let filterChoice = '';
    if (locationData.cities.length > 0) {
        filterType = 'city';
        filterChoice = locationData.cities[0];
    } else if (locationData.dbas.length > 0) {
        filterType = 'dba';
        filterChoice = locationData.dbas[0].toString();
    } else if (locationData.districts.length > 0) {
        filterType = 'district';
        filterChoice = locationData.districts[0].toString();
    } else if (locationData.locations.length > 1) {
        filterType = 'locations';
        rdata.data.filter_locations = locationData.locations;
    } else if (locationData.locations.length > 0) {
        filterType = 'location';
        filterChoice = (locationData.locations[0]) ? parseInt(locationData.locations[0], 10) : '';
    } else if (locationData.states.length > 0) {
        filterType = 'state';
        filterChoice = locationData.states[0];
    }
    rdata.data.filter_types = filterType;
    rdata.data.filter_first_choice = filterChoice;
    rdata.data.from_day = rdata.data.payload.dateRange.fromDay;
    rdata.data.to_day = rdata.data.payload.dateRange.toDay;
    rdata.data.back_num = rdata.data.payload.dateRange.daysBack;
    rdata.data.back_type = 'days';
    rdata.data.run_time_hour = rdata.data.run_time.substr(0, 2);
    rdata.data.emails_str = rdata.data.emails.toString().replace(',', ', ');
    return rdata;
};


// WEBPACK FOOTER //
// ./src/Fuse/restClientPostProcess.js